import Swiper from 'swiper/dist/js/swiper';
import PopupFullscreen from './popup-fullscreen.pug';
import CardPopup from '../../card/card-popup/card-popup';

export default {
  data() {
    return {
      showSlider: true,
    };
  },
  props: {
    mediaArray: {
      type: Array,
      default: () => [],
    },
    clickedIndex: {
      type: Number,
      default: 0,
    },
    fullscreenbuttontext: {
      type: Array,
      default: () => [],
    },
  },
  template: PopupFullscreen(),
  delimiters: ['${', '}}'],
  components: {
    CardPopup,
  },
  methods: {
    closePopup() {
      this.$emit('close-fullscreen-popup');
      window.bodyLock.clearAllBodyScrollLocks();
    },
  },
  mounted() {
    const { clickedIndex } = this;
    this.slider = new Swiper(this.$refs.fullSlider, {
      slidesPerView: 1,
      initialSlide: clickedIndex || 0,
      navigation: {
        nextEl: this.$el.querySelector('.popup-fullscreen__btn--next'),
        prevEl: this.$el.querySelector('.popup-fullscreen__btn--prev'),
      },
      on: {
        init() {
          const count = this.el.querySelector('.sliderButtons__counter');
          count.querySelector('[data-name=activeSlide]').textContent = this.realIndex + 1;
          count.querySelector('[data-name=slidesLength]').textContent = this.slides.length;
        },
        slideChange() {
          const count = this.el.querySelector('.sliderButtons__counter');
          count.querySelector('[data-name=activeSlide]').textContent = this.realIndex + 1;
          count.querySelector('[data-name=slidesLength]').textContent = this.slides.length;
        },
      },
    });
  },
};



// WEBPACK FOOTER //
// ./blocks/popup/fullscreen/popup-fullscreen.js